<template>
  <tr>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ sucursal.fecha | moment("DD MMMM YYYY") }}</td>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ sucursal.sucursal.nombre }}</td>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ sucursal.sucursal.clave }}</td>
  </tr>
</template>

<script>
export default {
  name: 'ItemSucursales',
  props: {
    sucursal: Object
  }
}
</script>
